import React, { useState, useEffect } from "react";


const NCSCUpdate = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),
        GenderTotal3: 0,
        GenderTotalVIEW: 0,
        GenderMale4: 0,
        GenderFemale5: 0,
        GenderTransgender6: 0,
        CasteSc7: 0,
        CasteSt8: 0,
        CasteObc9: 0,
        CasteOthers10: 0,
        Vhmale11: 0,
        Vhfemale12: 0,
        Vhtransgender13: 0,
        Hhmale14: 0,
        Hhfemale15: 0,
        Hhtransgender16: 0,
        Ohmale17: 0,
        Ohfemale18: 0,
        Ohtransgender19:0,
        Clmale20: 0,
        Clfemale21: 0,
        Cltransgender22: 0,
        Mrmale23: 0,
        Mrfemale24: 0,
        Mrtransgender25: 0,
        Mdmale26: 0,
        Mdfemale27: 0,
        Mdtransgender28: 0,
        OthersMale29: 0,
        OthersFemale30: 0,
        OthersTransgender31: 0,
        TotalCat:0
    });

    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }

        await fetch(process.env.REACT_APP_API_LINK +'api/NCSCDA/GetNcscDaDetails', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    setFormData({
                        GenderTotal3: maindata.genderTotal3,
                        GenderMale4: maindata.genderMale4,
                        GenderFemale5: maindata.genderFemale5,
                        GenderTransgender6: maindata.genderTransgender6,
                        CasteSc7: maindata.casteSc7,
                        CasteSt8: maindata.casteSt8,
                        CasteObc9: maindata.casteObc9,
                        CasteOthers10: maindata.casteOthers10,
                        Vhmale11: maindata.vhmale11,
                        Vhfemale12: maindata.vhfemale12,
                        Vhtransgender13: maindata.vhtransgender13,
                        Hhmale14: maindata.hhmale14,
                        Hhfemale15: maindata.hhfemale15,
                        Hhtransgender16: maindata.hhtransgender16,
                        Ohmale17: maindata.ohmale17,
                        Ohfemale18: maindata.ohfemale18,
                        Ohtransgender19: maindata.ohtransgender19,      
                        Clmale20: maindata.clmale20,
                        Clfemale21: maindata.clfemale21,
                        Cltransgender22: maindata.cltransgender22,
                        Mrmale23: maindata.mrmale23,
                        Mrfemale24: maindata.mrfemale24,
                        Mrtransgender25: maindata.mrtransgender25,
                        Mdmale26: maindata.mdmale26,
                        Mdfemale27: maindata.mdfemale27,
                        Mdtransgender28: maindata.mdtransgender28,
                        OthersMale29: maindata.othersMale29,
                        OthersFemale30: maindata.othersFemale30,
                        OthersTransgender31: maindata.othersTransgender31,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                        TotalCat: maindata.totalCat
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        setFormData({ ...formData, [e.target.name]: Number(e.target.value)});
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
 

        await fetch(process.env.REACT_APP_API_LINK +'api/NCSCDA/UpdateDetailsNcscDa2', {
            method: 'POST',
            headers: {  
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => getdata())
        props.setGTotal(props.GTotal + 1)
    };

    




    useEffect(() => {
        getdata()

    }, [props.Change])



    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };
   

    return (
        load ? null : <>
          
                <tr scope="row"  >

                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.sno}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.name}  <b> <br />{props.target >= 0 ? ("Annual Target(" + props.target + ")") : ""}</b>

                    </td>

                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        <label> {formData.GenderTotal3}</label>

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="genderMale4"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="genderMale4"
                            style={{ textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.GenderMale4}
                        /> : formData.GenderMale4}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="genderFemale5"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="genderFemale5"
                            style={{ textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.GenderFemale5}
                        /> : formData.GenderFemale5}


                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="genderTransgender6"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="genderTransgender6"
                            style={{ textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.GenderTransgender6}
                        /> : formData.GenderTransgender6}

                    </td>


                
            
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="casteSc7"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="casteSc7"
                            style={formData.GenderTotal3 !== formData.CasteSc7 + formData.CasteSt8 + formData.CasteObc9 + formData.CasteOthers10 ? { textAlign: 'center', minWidth: 70, color: 'red', border: '1px solid red' } : { minWidth: 70, textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.CasteSc7}
                        /> : formData.CasteSc7}

                    </td>

                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="casteSt8"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="casteSt8"
                            style={formData.GenderTotal3 !== formData.CasteSc7 + formData.CasteSt8 + formData.CasteObc9 + formData.CasteOthers10 ? { textAlign: 'center', minWidth: 70, color: 'red', border: '1px solid red' } : { minWidth: 70, textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.CasteSt8}
                        /> : formData.CasteSt8}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="casteObc9"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="casteObc9"
                            style={formData.GenderTotal3 !== formData.CasteSc7 + formData.CasteSt8 + formData.CasteObc9 + formData.CasteOthers10 ? { textAlign: 'center', minWidth: 70, color: 'red', border: '1px solid red' } : { minWidth: 70, textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.CasteObc9}
                        /> : formData.CasteObc9}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="casteOthers10"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="casteOthers10"
                            style={formData.GenderTotal3 !== formData.CasteSc7 + formData.CasteSt8 + formData.CasteObc9 + formData.CasteOthers10 ? { textAlign: 'center', minWidth: 70, color: 'red', border: '1px solid red' } : { minWidth: 70, textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.CasteOthers10}
                        /> : formData.CasteOthers10}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="vhmale11"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="vhmale11"
                            style={formData.GenderMale4 !== formData.Vhmale11 + formData.Hhmale14 + formData.Ohmale17 + formData.Clmale20 + formData.Mrmale23 + formData.Mdmale26 + formData.OthersMale29 ? { textAlign: 'center', color: 'darkorange', border: '1px solid darkorange' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Vhmale11}
                        /> : formData.Vhmale11}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="vhfemale12"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="vhfemale12"
                            style={formData.GenderFemale5 !== formData.Vhfemale12 + formData.Hhfemale15 + formData.Ohfemale18 + formData.Clfemale21 + formData.Mrfemale24 + formData.Mdfemale27 + formData.OthersFemale30 ? { textAlign: 'center', color: 'purple', border: '1px solid purple' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Vhfemale12}
                        /> : formData.Vhfemale12}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="vhtransgender13"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="vhtransgender13"
                            style={formData.GenderTransgender6 !== formData.Vhtransgender13 + formData.Hhtransgender16 + formData.Ohtransgender19 + formData.Cltransgender22 + formData.Mrtransgender25 + formData.Mdtransgender28 + formData.OthersTransgender31 ? { textAlign: 'center', color: 'darkgreen', border: '1px solid darkgreen' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Vhtransgender13}
                        /> : formData.Vhtransgender13}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="hhmale14"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="hhmale14"
                            style={formData.GenderMale4 !== formData.Vhmale11 + formData.Hhmale14 + formData.Ohmale17 + formData.Clmale20 + formData.Mrmale23 + formData.Mdmale26 + formData.OthersMale29 ? { textAlign: 'center', color: 'darkorange', border: '1px solid darkorange' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Hhmale14}
                        /> : formData.Hhmale14}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="hhfemale15"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="hhfemale15"
                            style={formData.GenderFemale5 !== formData.Vhfemale12 + formData.Hhfemale15 + formData.Ohfemale18 + formData.Clfemale21 + formData.Mrfemale24 + formData.Mdfemale27 + formData.OthersFemale30 ? { textAlign: 'center', color: 'purple', border: '1px solid purple' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Hhfemale15}
                        /> : formData.Hhfemale15}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="hhtransgender16"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="hhtransgender16"
                            style={formData.GenderTransgender6 !== formData.Vhtransgender13 + formData.Hhtransgender16 + formData.Ohtransgender19 + formData.Cltransgender22 + formData.Mrtransgender25 + formData.Mdtransgender28 + formData.OthersTransgender31 ? { textAlign: 'center', color: 'darkgreen', border: '1px solid darkgreen' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Hhtransgender16}
                        /> : formData.Hhtransgender16}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="ohmale17"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="ohmale17"
                            style={formData.GenderMale4 !== formData.Vhmale11 + formData.Hhmale14 + formData.Ohmale17 + formData.Clmale20 + formData.Mrmale23 + formData.Mdmale26 + formData.OthersMale29 ? { textAlign: 'center', color: 'darkorange', border: '1px solid darkorange' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Ohmale17}
                        /> : formData.Ohmale17}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="ohfemale18"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="ohfemale18"
                            style={formData.GenderFemale5 !== formData.Vhfemale12 + formData.Hhfemale15 + formData.Ohfemale18 + formData.Clfemale21 + formData.Mrfemale24 + formData.Mdfemale27 + formData.OthersFemale30 ? { textAlign: 'center', color: 'purple', border: '1px solid purple' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Ohfemale18}
                        /> : formData.Ohfemale18}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="ohtransgender19"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="ohtransgender19"
                            style={formData.GenderTransgender6 !== formData.Vhtransgender13 + formData.Hhtransgender16 + formData.Ohtransgender19 + formData.Cltransgender22 + formData.Mrtransgender25 + formData.Mdtransgender28 + formData.OthersTransgender31 ? { textAlign: 'center', color: 'darkgreen', border: '1px solid darkgreen' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Ohtransgender19}
                        /> : formData.Ohtransgender19}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="clmale20"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="clmale20"
                            style={formData.GenderMale4 !== formData.Vhmale11 + formData.Hhmale14 + formData.Ohmale17 + formData.Clmale20 + formData.Mrmale23 + formData.Mdmale26 + formData.OthersMale29 ? { textAlign: 'center', color: 'darkorange', border: '1px solid darkorange' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Clmale20}
                        /> : formData.Clmale20}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="clfemale21"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="clfemale21"
                            style={formData.GenderFemale5 !== formData.Vhfemale12 + formData.Hhfemale15 + formData.Ohfemale18 + formData.Clfemale21 + formData.Mrfemale24 + formData.Mdfemale27 + formData.OthersFemale30 ? { textAlign: 'center', color: 'purple', border: '1px solid purple' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Clfemale21}
                        /> : formData.Clfemale21}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="cltransgender22"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="cltransgender22"
                            style={formData.GenderTransgender6 !== formData.Vhtransgender13 + formData.Hhtransgender16 + formData.Ohtransgender19 + formData.Cltransgender22 + formData.Mrtransgender25 + formData.Mdtransgender28 + formData.OthersTransgender31 ? { textAlign: 'center', color: 'darkgreen', border: '1px solid darkgreen' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Cltransgender22}
                        /> : formData.Cltransgender22}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="mrmale23"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="mrmale23"
                            style={formData.GenderMale4 !== formData.Vhmale11 + formData.Hhmale14 + formData.Ohmale17 + formData.Clmale20 + formData.Mrmale23 + formData.Mdmale26 + formData.OthersMale29 ? { textAlign: 'center', color: 'darkorange', border: '1px solid darkorange' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Mrmale23}
                        /> : formData.Mrmale23}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="mrfemale24"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="mrfemale24"
                            style={formData.GenderFemale5 !== formData.Vhfemale12 + formData.Hhfemale15 + formData.Ohfemale18 + formData.Clfemale21 + formData.Mrfemale24 + formData.Mdfemale27 + formData.OthersFemale30 ? { textAlign: 'center', color: 'purple', border: '1px solid purple' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Mrfemale24}
                        /> : formData.Mrfemale24}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="mrtransgender25"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="mrtransgender25"
                            style={formData.GenderTransgender6 !== formData.Vhtransgender13 + formData.Hhtransgender16 + formData.Ohtransgender19 + formData.Cltransgender22 + formData.Mrtransgender25 + formData.Mdtransgender28 + formData.OthersTransgender31 ? { textAlign: 'center', color: 'darkgreen', border: '1px solid darkgreen' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Mrtransgender25}
                        /> : formData.Mrtransgender25}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="mdmale26"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="mdmale26"
                            style={formData.GenderMale4 !== formData.Vhmale11 + formData.Hhmale14 + formData.Ohmale17 + formData.Clmale20 + formData.Mrmale23 + formData.Mdmale26 + formData.OthersMale29 ? { textAlign: 'center', color: 'darkorange', border: '1px solid darkorange' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Mdmale26}
                        /> : formData.Mdmale26}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="mdfemale27"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="mdfemale27"
                            style={formData.GenderFemale5 !== formData.Vhfemale12 + formData.Hhfemale15 + formData.Ohfemale18 + formData.Clfemale21 + formData.Mrfemale24 + formData.Mdfemale27 + formData.OthersFemale30 ? { textAlign: 'center', color: 'purple', border: '1px solid purple' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Mdfemale27}
                        /> : formData.Mdfemale27}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="mdtransgender28"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="mdtransgender28"
                            style={formData.GenderTransgender6 !== formData.Vhtransgender13 + formData.Hhtransgender16 + formData.Ohtransgender19 + formData.Cltransgender22 + formData.Mrtransgender25 + formData.Mdtransgender28 + formData.OthersTransgender31 ? { textAlign: 'center', color: 'darkgreen', border: '1px solid darkgreen' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.Mdtransgender28}
                        /> : formData.Mdtransgender28}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="othersMale29"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="othersMale29"
                            style={formData.GenderMale4 !== formData.Vhmale11 + formData.Hhmale14 + formData.Ohmale17 + formData.Clmale20 + formData.Mrmale23 + formData.Mdmale26 + formData.OthersMale29 ? { textAlign: 'center', color: 'darkorange', border: '1px solid darkorange' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.OthersMale29}
                        /> : formData.OthersMale29}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="othersFemale30"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="othersFemale30"
                            style={formData.GenderFemale5 !== formData.Vhfemale12 + formData.Hhfemale15 + formData.Ohfemale18 + formData.Clfemale21 + formData.Mrfemale24 + formData.Mdfemale27 + formData.OthersFemale30 ? { textAlign: 'center', color: 'purple', border: '1px solid purple' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.OthersFemale30}
                        /> : formData.OthersFemale30}

                    </td>
                    <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                        {props.edit ? <input
                            type="number"
                            min="0"
                            id="othersTransgender31"
                            className="form-control" maxLength="4" onKeyPress={inputHandler}
                            name="othersTransgender31"
                            style={formData.GenderTransgender6 !== formData.Vhtransgender13 + formData.Hhtransgender16 + formData.Ohtransgender19 + formData.Cltransgender22 + formData.Mrtransgender25 + formData.Mdtransgender28 + formData.OthersTransgender31 ? { textAlign: 'center', color: 'darkgreen', border: '1px solid darkgreen' } : { textAlign: 'center' }}
                            onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                           onWheel={(e) => e.target.blur()} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.OthersTransgender31}
                        /> : formData.OthersTransgender31}

                    </td>



                </tr>
        </>
    );
};

export default NCSCUpdate;
